import { AppInitService } from './app-init.service';

export function initializeApp(appInitService: AppInitService) {
  return () => appInitService.init();
}
